// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__4CB2q","Container":"Footer_Container__XcMDz","Terms":"Footer_Terms__OZGaJ","Social":"Footer_Social__pylJs","Icono":"Footer_Icono__jKwnM"};